import React from "react";

const OnlineMagazaSection = () => {
  return (
    <section>
      <h1 className="main-section-title" style={{display: 'flex', flexDirection: 'row-reverse', margin: '20px', fontWeight: '700'}}>Online Mağaza</h1>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <h2 style={{color: '#333', fontSize: '24px'}}>Online Mağazamız Yakında Açılıyor!</h2>
        <p style={{color: '#666', fontSize: '16px', textAlign: 'center', maxWidth: '500px'}}>
          Çok yakında online mağazamızdan ürünlerimizi sipariş edebileceksiniz. 
          Şimdilik menümüzü inceleyebilir ve rezervasyon yapabilirsiniz.
        </p>
        <div style={{
          display: 'none',
          gap: '15px',
          marginTop: '20px'
        }}>
          <button style={{
            padding: '12px 24px',
            backgroundColor: '#8B4513',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px'
          }}>
            Rezervasyon Yap
          </button>
          <button style={{
            padding: '12px 24px',
            backgroundColor: 'transparent',
            color: '#8B4513',
            border: '2px solid #8B4513',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px'
          }}>
            İletişime Geç
          </button>
        </div>
      </div>
    </section>
  );
};

export default OnlineMagazaSection; 